export default __webpack_public_path__ + "static/media/Formato de Cargue Contactos Masivo_IDEA.f6135087.xlsm";